import { format } from 'date-fns';

/**
 * THIN-7939: `dateOfService` arrives from the API as a plain calendar date (`2026-08-24`,
 * sometimes carrying a UTC time component). `new Date('2026-08-24')` resolves to UTC midnight,
 * so formatting it directly renders the *previous* day for every user behind UTC — which is how
 * the delete dialog came to offer "August 23, 2026" for a note dated the 24th.
 *
 * Shift the instant by the local offset so the wall-clock date matches the calendar date the
 * server meant. This is the same reading the document lists already use; keeping one copy stops
 * the raw `format(new Date(dateOfService), ...)` pattern from being reintroduced.
 */
export const formatDateOfService = (dateOfService: any, pattern: string): string => {
  if (!dateOfService) return '';
  const parsed = new Date(dateOfService);
  if (Number.isNaN(parsed.valueOf())) return '';
  return format(new Date(parsed.valueOf() + parsed.getTimezoneOffset() * 60 * 1000), pattern);
};
